import React from 'react';
 
const ClientProvider = React.createContext(null);
 
export default ClientProvider;